import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ReactDOM from 'react-dom/client';
import './index.css';
//
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from './theme';
import { UIContextProvider } from './context/UIContext';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(<App />);

serviceWorker.unregister();

reportWebVitals();
